export default "__VITE_ASSET__JoYf4v5P__"